import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADD_AGENT = 'add agent'
export const NAME = 'name'
export const NUMBER = 'number'
export const EDIT_AGENT = 'edit agent'
export const REQUIRED_FIELDS = 'required fields'
export const AGENT_ADDED = 'agent added'

export default {
  [PORTUGUESE]: {
    [ADD_AGENT]: 'Adicionar Agente',
    [NAME]: 'Nome',
    [NUMBER]: 'Número',
    [EDIT_AGENT]: 'Editar Agente',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
    [AGENT_ADDED]: 'Agente adicionado',
  },

  [ENGLISH]: {
    [ADD_AGENT]: 'Add Agent',
    [NAME]: 'Name',
    [NUMBER]: 'Number',
    [EDIT_AGENT]: 'Edit Agent',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
    [AGENT_ADDED]: 'Agent added',
  },

  [SPANISH]: {
    [ADD_AGENT]: 'Agregar Agente',
    [NAME]: 'Nombre',
    [NUMBER]: 'Número',
    [EDIT_AGENT]: 'Editar Agente',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
    [AGENT_ADDED]: 'Agente agregado',
  },
}
